import React, { useState, useEffect } from "react";
import { acceptInvitation } from "../../services/userManagementService";
import { School, Mail, Lock, User, AlertCircle } from "lucide-react";
import "../../styles/AcceptInvite.css";

const AcceptInvite = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    displayName: "",
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    if (!token) {
      setError("Invalid invitation link. Please check your email for the correct link.");
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (formData.password.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await acceptInvitation(token, formData.password, formData.displayName);
      // Redirect to login or dashboard
      window.location.href = "/";
    } catch (error) {
      setError(error.message || "Failed to accept invitation");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="accept-invite-container">
      <div className="accept-invite-card">
        <div className="accept-invite-header">
          <School className="accept-invite-icon" />
          <h1 className="accept-invite-title">Welcome to Iconik Portal</h1>
          <p className="accept-invite-subtitle">
            You've been invited to join a school account. Please set up your account below.
          </p>
        </div>

        {error && (
          <div className="alert alert-error">
            <AlertCircle className="alert-icon" />
            {error}
          </div>
        )}

        {token && (
          <form onSubmit={handleSubmit} className="accept-invite-form">
            <div className="form-group">
              <label htmlFor="displayName" className="form-label">
                <User className="form-icon" />
                Display Name
              </label>
              <input
                type="text"
                id="displayName"
                value={formData.displayName}
                onChange={(e) => setFormData({ ...formData, displayName: e.target.value })}
                className="form-input"
                placeholder="Enter your name"
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                <Lock className="form-icon" />
                Password
              </label>
              <input
                type="password"
                id="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="form-input"
                placeholder="Create a password"
                required
                disabled={loading}
                minLength={6}
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword" className="form-label">
                <Lock className="form-icon" />
                Confirm Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                className="form-input"
                placeholder="Confirm your password"
                required
                disabled={loading}
                minLength={6}
              />
            </div>

            <button
              type="submit"
              className="submit-button"
              disabled={loading}
            >
              {loading ? "Creating Account..." : "Create Account"}
            </button>
          </form>
        )}

        <div className="accept-invite-footer">
          <p>
            Already have an account?{" "}
            <a href="/" className="link">
              Sign in instead
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AcceptInvite;